import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialLinkedin = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="social-linkedin"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.211 15.037c0-1.655-.582-2.786-2.044-2.786-1.112 0-1.153.765-1.446 1.5-.107.263-.135.627-.135.997v6.877h-4.031s.054-11.16 0-12.314h4.031v1.744a.267.267 0 01-.024.04h.024v-.04c.54-.84.876-1.907 3.016-1.907 2.651 0 4.643 1.633 4.643 5.417v7.06h-4.034v-6.588zM6.307 7.63h-.025c-1.353 0-2.228-.948-2.228-2.129 0-1.207.902-2.129 2.28-2.129 1.38 0 2.229.922 2.256 2.13 0 1.18-.875 2.128-2.283 2.128zm2.02 13.996H4.291V9.311h4.034v12.314z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

SocialLinkedin.defaultProps = {
  className: null,
};

SocialLinkedin.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialLinkedin;
